import PosCartActions from '../../../actions/PosCartActions';

class AddByTabMessage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            disableAdd : []
        };

        this.add = this.add.bind(this);
    }

    add(data) {
        var self = this;

        if (data.qty === 0)
            return;

        var arr = this.state.disableAdd;
        arr.push(data.serialNo);
        this.setState({ disableAdd : arr });

        PosCartActions.addItemToCart(data.item, this.props.guest, data.qty);
    }

    render() {
        var self = this;

        var messageArr = this.props.messageArr;
        var disableAdd = this.state.disableAdd;

        return (
            <div className='popup popup__transparent'>
                <div
                    className='popup__content add-by-tab-msg'>

                    <div className='popup-header'>
                        NOTIFICATION

                        <div
                            className='popup-close'
                            onClick={() => { this.props.onClose(); }}>

                            <i className='fa fa-times' aria-hidden='true' />
                        </div>
                    </div>

                    <div className='add-by-tab-msg__block'>
                        { messageArr.map((msg, i) => {

                            var disabled = false;
                            for (var i=0; i<disableAdd.length; i++) {
                                if (disableAdd[i] === msg.serialNo)
                                    disabled = true;
                            }

                            if (msg.found) {
                                return (
                                    <div className='add-by-tab-msg__row'>
                                        <div className='add-by-tab-msg__row--serial'>
                                            {msg.serialNo}
                                        </div>

                                        <div className='add-by-tab-msg__row--qty'>
                                            Inventory: {msg.qty}
                                        </div>

                                        <div
                                            className={'add-by-tab-msg__row--add '+((msg.qty === 0 || disabled) ? 'btn-green__disabled' : '')}
                                            onClick={self.add.bind(self, msg)}>

                                            Add
                                        </div>
                                    </div>
                                );
                            }

                            if (!msg.found) {
                                return (
                                    <div className='add-by-tab-msg__row'>
                                        <div className='add-by-tab-msg__row--serial'>
                                            {msg.serialNo}
                                        </div>

                                        <div className='add-by-tab-msg__row--qty'>
                                            NOT FOUND
                                        </div>
                                    </div>
                                );
                            }

                            return null;
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default AddByTabMessage;


// 1736,1903,10x2643, 1212,5x2783,2x2787


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/notification/AddByTabMessage.react.jsx